import { CAMPAIGN_TABS } from '@/pages/campaign/CreatePage/types';
import { createContext, ReactNode, useState } from 'react';

export interface CampaignCreateContextType {
    currentTab: CAMPAIGN_TABS;
    setCurrentTab: (tab: CAMPAIGN_TABS) => void;
}

export const CampaignCreateContext = createContext<CampaignCreateContextType>({
    currentTab: CAMPAIGN_TABS.AVATAR,
    setCurrentTab: () => {},
});

export const CampaignCreateContextProvider = ({ children }: { children: ReactNode }) => {
    const [currentTab, setCurrentTab] = useState<CAMPAIGN_TABS>(CAMPAIGN_TABS.AVATAR);

    return <CampaignCreateContext.Provider value={{ currentTab, setCurrentTab }}>{children}</CampaignCreateContext.Provider>;
};
